'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/millisecondsAgo.js
// module id = 569
// module chunks = 0